import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import { marketCategories } from '../../../../utils/market';
import { setHighlightItem } from '../../../store/slices/common/commonSlice';
import CategorySubNavbarComponent from './CategorySubNavbarComponent';

export default function MarketCategoryBar() {
  const dispatch = useDispatch();
  const router = useRouter();
  const { city, tag_filter = 'most_popular' } = router.query;
  const lang = useSelector(({ common }) => common?.language);

  const categoryTabHandler = async (tab) => {
    if (tab?.name === 'Home') {
      await dispatch(setHighlightItem('Home'));
      router.push(
        `${process.env.NEXT_PUBLIC_FRONTEND_URL}/market?city=${city}&tag_filter=${tag_filter}`
      );
    } else {
      await dispatch(setHighlightItem(tab?.id));
      router.push(
        `${process.env.NEXT_PUBLIC_FRONTEND_URL}/market/${tab?.id}?city=${city}&tag_filter=${tag_filter}`
      );
    }
  };

  return (
    <CategorySubNavbarComponent
      categories={marketCategories(lang, city)}
      categoryTabHandler={categoryTabHandler}
    />
  );
}
